import API_BASE_URL from "../utils/config";
import request from "../utils/request";

export async function postPaper(data) {
  const url = `${API_BASE_URL}/papers`;
  return request({
    url,
    method: "post",
    data,
  });
}

// export async function fetchPapers(id = "") {
//   const url = `${API_BASE_URL}/papers?examId=${id}`;
//   return request({
//     url,
//     method: "get",
//   });
// }
export async function fetchPapers(data) {
  const url = `${API_BASE_URL}/papers`;
  return request({
    url,
    method: "get",
    data,
  });
}

export async function paperDelete(id) {
  const url = `${API_BASE_URL}/papers/${id}`;
  return request({
    url,
    method: "delete",
  });
}

export async function paperEdit(data) {
  const { id, ...editData } = data;
  const url = `${API_BASE_URL}/papers/${id}`;
  return request({
    url,
    method: "put",
    data: editData,
  });
}

export async function httpGetPaper(id) {
  const url = `${API_BASE_URL}/papers/${id}`;
  return request({
    url,
    method: "get",
  });
}

export async function httpCreatePaperCurriculum(data) {
  const modData = { file: data, name: data.name };
  const url = `${API_BASE_URL}/multimedia-files`;
  const formData = toFormData(modData);
  return request({
    url,
    method: "post",
    formData,
    upload: true,
    config: {
      headers: {
        "content-type": "multipart/form-data",
      },
    },
  });
}

export async function httpPaperCurriculumDelete(id) {
  const url = `${API_BASE_URL}/multimedia-files/${id}`;
  return request({
    url,
    method: "delete",
  });
}

function toFormData(data) {
  const formData = new FormData();
  formData.append("file", data.file);
  formData.append("name", data.name);
  return formData;
}
